module.exports = __webpack_public_path__ + "static/media/HarveyWaroonaReporter-devicecomp-min@2x.95b4f32a.webp";